import { useTranslation } from "react-i18next";

export default function Company({module, prefix, ciWidth, reverse, className, img, title, comment}){
  const {t} = useTranslation();
  const ci = require(`assets/images/solutions/${module}/${prefix}/ci.png`);
  const image = img ?? "company.jpg";
  const company = require(`assets/images/solutions/${module}/${prefix}/${image}`);
  const pcDisplay = reverse!==undefined&&reverse? "flex-row-reverse":"flex-row";

  const titleId = title ?? `${module}.company.${prefix}.title`;
  const titleStr = t(titleId)
  const commentId = comment ?? `${module}.company.${prefix}.comment`;
  const commentStr = t(commentId)

  return (
    <div className={`${className} flex flex-col lg:${pcDisplay} lg:items-center lg:w-[1200px] lg:mt-20`}>
      <div className={`flex flex-col lg:w-[620px] lg:pr-16 my-10 ${reverse? 'lg:ml-10':''}`}>
        <div className={`lg:mb-10 h-14 w-[${ciWidth}px] `}>
          <img src={ci} style={{width:`${ciWidth}px`, height:``}} alt='ci'/>
        </div>
        <p className="text-xl lg:text-[29px] font-thin mb-10 lg:mb-20 leading-normal" 
          dangerouslySetInnerHTML={{__html:titleStr}}></p>
        <p className="text-gray-500 text-xm"
          dangerouslySetInnerHTML={{__html:commentStr}}></p>
      </div>
      <div>
        <img src={company} className="lg:w-[580px]" alt='company concept'/>
      </div>
    </div>
  );
}